import { paymentModeEnum } from "../../../../state/initialState";
import {
  removeGlobalErrorMessageIfMatchesThisString,
  updateGlobalErrorMessage
} from "../../../../actions/globalError";
import React, { Component } from "react";
import { connect } from "react-redux";
import objectAssign from "object-assign";
import {
  updateCheckoutAppointmentStepData,
  createGiftCertificate,
  updateInvoice,
  updateGiftCertSaleFormVisibility
} from "../../../../actions/checkoutAppointmentStep";
import { createPayloadItemFromInvoiceItem } from "../../../shared/functions/confirmServicePriceChangeAndGenerateInvoice";
import { decimalPoint } from "../../../../utils/helpers";
import { ValidMe } from "../../../shared/validMeReact";
import Txt from "../../../shared/textInput";
const maxPrice = 10000;

@connect(mapStateToProps)
export default class GiftCertSaleForm extends Component {
  constructor(props) {
    super(props);
    this.state = { hoveredHelpGiftCertEmail: false };
  }

  componentWillMount() {
    let { businessName } = this.props;
    this.updateCheckoutStep({
      giftCertSaleTitle: businessName + " Gift Certificate"
    });
  }

  dispatchUpdateCheckoutAppointmentStepData = data => {
    this.props.dispatch(updateCheckoutAppointmentStepData(data));
  };

  updateCheckoutStep = data => {
    let newData = objectAssign(
      {},
      this.props.checkoutAppointmentStepData,
      data
    );
    this.dispatchUpdateCheckoutAppointmentStepData(newData);
  };

  handleGiftCertTitleChange = ev => {
    this.updateCheckoutStep({ giftCertSaleTitle: ev.target.value });
  };

  changeGiftCertValueWithinConstraints = ev => {
    let giftCertValue = ev.target.value.replace("$", "");

    if (
      (/[0-9]+\.?([0-9]{0,2})?$/.test(giftCertValue) &&
        Number(giftCertValue) <= maxPrice) ||
      giftCertValue.length == 0
    ) {
      const decimalPlace = giftCertValue.split(".")[1];
      if (decimalPlace && decimalPlace.length > 2) {
        return;
      }
      this.updateCheckoutStep({ giftCertSaleValue: giftCertValue });
    }
  };

  formatValueField = () => {
    let { giftCertSaleValue } = this.props.checkoutAppointmentStepData;
    this.updateCheckoutStep({
      giftCertSaleValue: decimalPoint(giftCertSaleValue)
    });
  };

  addGiftCertToInvoice = giftCertKey => {
    const { invoiceData } = this.props;
    const formattedDueDate =
      invoiceData.duedate.length > 9
        ? invoiceData.duedate
        : invoiceData.duedate.replace("Z", "T000000Z");

    let payload = {
      customerid: invoiceData.customerid,
      duedate: formattedDueDate,
      items: []
    };
    invoiceData.items.map(item => {
      let payloadItem = createPayloadItemFromInvoiceItem(item);
      payload.items.push(payloadItem);
    });
    let giftCertItem = { type: "GIFTCERT", reference: giftCertKey };
    payload.items.push(giftCertItem);

    let cb = () => {
      this.updateCheckoutStep({
        giftCertSaleTitle: "",
        giftCertSaleValue: "0"
      });
      this.props.dispatch(updateGiftCertSaleFormVisibility(false));
    };
    this.props.dispatch(updateInvoice(invoiceData.key, payload, cb));
  };

  handleAddGiftCert = () => {
    const { invoiceData, selectedCustomer } = this.props;
    let {
      giftCertSaleValue,
      giftCertSaleTitle
    } = this.props.checkoutAppointmentStepData;
    if (giftCertSaleTitle.length > 0 && giftCertSaleValue >= 1) {
      let cb = giftCertKey => {
        this.addGiftCertToInvoice(giftCertKey);
      };
      this.props.dispatch(
        createGiftCertificate(
          {
            value: giftCertSaleValue,
            message: giftCertSaleTitle,
            email: selectedCustomer.email
          },
          cb
        )
      );
    }
  };

  handleGiftCertEmailHelpMouseIn = () => {
    this.setState({ hoveredHelpGiftCertEmail: true });
  };

  handleGiftCertEmailHelpMouseOut = () => {
    this.setState({ hoveredHelpGiftCertEmail: false });
  };

  getGiftCertSaleForm = () => {
    const { invoiceData, selectedCustomer } = this.props;
    let {
      giftCertSaleValue,
      giftCertSaleTitle
    } = this.props.checkoutAppointmentStepData;
    let { Currency } = window.APP.LANGUAGE;
    let {
      GiftCertEmailHelpText,
      GiftCertValueTitle,
      GiftCertTitleTitle,
      GiftCertValuePlaceholder,
      GiftCertEmailTitle,
      ConfirmGiftCertSale
    } = window.APP.LANGUAGE.Pages.AppointmentCheckout;

    let disableAddBtn = !(
      giftCertSaleTitle.length > 0 && giftCertSaleValue >= 1
    );
    return (
      <div className="ui form giftcert_sale_form">
        <div>
          <div className="giftcert_value_title">{GiftCertValueTitle}</div>
          <Txt
            type="input"
            onBlur={this.formatValueField}
            fieldclasses="mrnull"
            className="giftcert_value active"
            onChange={this.changeGiftCertValueWithinConstraints}
            placeholder={GiftCertValuePlaceholder}
            value={giftCertSaleValue > 0 ? Currency + giftCertSaleValue : ""}
          ></Txt>
        </div>
        <div>
          <div className="giftcert_title_title">{GiftCertTitleTitle}</div>
          <Txt
            type="input"
            fieldclasses="mrnull"
            className="giftcert_title active"
            onChange={this.handleGiftCertTitleChange}
            value={giftCertSaleTitle}
          ></Txt>
        </div>
        <div>
          <div className="giftcert_email_title">
            {GiftCertEmailTitle}
            <span
              onMouseOver={this.handleGiftCertEmailHelpMouseIn}
              onMouseOut={this.handleGiftCertEmailHelpMouseOut}
              className="giftcert_email_tooltip"
            >
              {this.state.hoveredHelpGiftCertEmail ? (
                <div
                  className="giftcert_email_tooltip_text"
                  dangerouslySetInnerHTML={{ __html: GiftCertEmailHelpText }}
                ></div>
              ) : (
                ""
              )}
            </span>
          </div>
          <div className="giftcert_email">{selectedCustomer.email}</div>
        </div>
        <div>
          <div
            className={`ui button add_giftcert_button ${
              disableAddBtn ? "disabled" : ""
            }`}
            onClick={this.handleAddGiftCert}
            disabled={disableAddBtn}
          >
            {ConfirmGiftCertSale}
          </div>
        </div>
      </div>
    );
  };

  render() {
    return <div>{this.getGiftCertSaleForm()}</div>;
  }
}

function mapStateToProps(state) {
  return {
    currentBookingId: state.bookingReducer.currentBookingId,
    limitedPermissions: state.appointmentStepReducer.limitedPermissions,
    invoiceData: state.appointmentCheckoutReducer.invoiceData,
    checkoutAppointmentStepData:
      state.appointmentCheckoutReducer.checkoutAppointmentStepData,
    selectedCustomer:
      state.appointmentStepReducer.appointmentStepData.selectedCustomer,
    businessName: state.appointmentStepReducer.appointmentStepData.businessName
  };
}
